<template>
  <div
    :class="listContainerClass"
    class="d-flex justify-content-end text-left list-icons-container separator separator-icons"
  >
    <div class="d-flex flex-column justify-content-center">
      <span class="icon-container">
        <span :class="['status-icon', 'mx-1', 'text-success']" :title="$t('Within Coverage Area')">
          <font-awesome-icon :icon="'circle'" />
        </span> {{ $t('Within Coverage Area') }}
      </span>
      <span class="icon-container">
        <span :class="['status-icon', 'mx-1', 'text-info']" :title="$t('Outside Coverage Area')">
          <font-awesome-icon :icon="'circle'" />
        </span> {{ $t('Outside Coverage Area') }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BuyLeadsStatusIcons',
  props: {
    listContainerClass: {
      type: String,
      default: 'mr-3',
    },
  }
}
</script>
